$(document).ready(function() {

  window.onload = function() {
    setTimeout(() => {
               $("#loader").hide();
    console.log('----------------',$("#loader").length);
    $('body').removeClass('loader_new');
  }, 800);
}

//                   $("footer").css("height", "auto");
// var e = $("footer").outerHeight();
// $("body").css("padding-bottom", e), $("footer").css("height", e)

// animation 
new WOW().init();

wow = new WOW(
  {
    boxClass:     'wow',      // default
    animateClass: 'animated', // default
    offset:       0,          // default
    mobile:       true,       // default
    live:         true        // default
  }
)
wow.init();

// FOR  CMS PAGE
// $('.accordion-title').click(function(e) {
//   e.preventDefault();
//   $('.panel').slideUp('100');
//   $('.panel').removeClass('active');
//   $('.accordion-title').removeClass('active');
//   if (!$(this).parent().find('.panel').is(":visible")) {
//     $(this).parent().find('.panel').slideToggle('500');
//     $(this).addClass('active');
//   }
// });

    /********* START MOBILE MENU ********/
    $(".hamburger").click(function(k) {
        k.preventDefault();
        $(this).toggleClass("is-active");
        $(".menu-bar").toggleClass("is-active");
        $('body,html').toggleClass('scrollno');
    });
    /********* END MOBILE MENU********/
    /********* START ACCORDION ********/
    $("body").on('click', '.js-accordion-title', function(e) {
        e.preventDefault();
        $(".js-accordion-title").removeClass("active");
        $(".accordion-content").slideUp();
        if (!$(this).next().is(":visible")) {
            $(this).next().slideDown();
            $(this).addClass("active");
        }
    });
    /********* On scroll heder Sticky *********/
    $(window).scroll(function() {
        var scroll = $(window).scrollTop();
        if (scroll >= 100) {
            $("header").addClass("head-sticky");
        } else {
            $("header").removeClass("head-sticky");
        }
    });
    //END
    //header height wrapper top spacing js start
    var header_hright = $('header').outerHeight();
	var topann = $('.topbar-header').outerHeight();
	var totalheight =  (header_hright + topann);
    $('.wrapper').css('margin-top', totalheight + 'px');
    /********* END ACCORDION ********/

    // INNER PAGE HEADER
    var header_hright = $('.inner-header').outerHeight();
    $('.wrapper').css('margin-top', header_hright + 'px');
    $(".tbh-wrap").click(function(e) {
      e.preventDefault();
      $(".switcher-content__wrapper").addClass("active");
    });
    $(".switcher-content__button-close").click(function(e) {
      e.preventDefault();
      $(".switcher-content__wrapper").removeClass("active");
    });
    // Accordian JS
    function close_accordion_section() {
        jQuery('.accordion .accordion-section-title').removeClass('active');
        jQuery('.accordion .accordion-section-content').slideUp(300).removeClass('open');
    }
    jQuery('.accordion-section-title').click(function(e) {
        // Grab current anchor value
        var currentAttrValue = jQuery(this).attr('href');
        if (jQuery(e.target).is('.active')) {
            close_accordion_section();
        } else {
            close_accordion_section();
            // Add active class to section title
            jQuery(this).addClass('active');
            // Open up the hidden content panel
            jQuery('.accordion ' + currentAttrValue).slideDown(300).addClass('open');
        }
        e.preventDefault();
    });
    $(".pro_img_slider").slick({
      dots: false,
      arrows: false,
      slidesToShow: 3,
      slidesToScroll: 3,
      infinite: true,
      cssEase: 'linear',
      pauseOnFocus: false,
      pauseOnHover: false,
      pauseOnDotsHover: false,
      accessibility:true,
      autoplay:true,
      autoplaySpeed: 3000,
      focusOnSelect: true,      
      rtl: true ,
        responsive: [{
            breakpoint: 767,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
            }
        }, ]
    });
    $('.comming-soon-slider').slick({
        speed: 800,
        autoplay: true,
        autoplaySpeed: 800,
        centerMode: false,
      	pauseOnFocus: false,
        pauseOnHover: false,
        pauseOnDotsHover: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        initialSlide: 1,
        arrows: false,
        buttons: false
    });
    //ADD CLASS ANIMATION
    var cnt = 0;
    setInterval(function() {
        var lenn = 0;
        $('.llw-animated-text').each(function(i, v) {
            if ($(this).find('.animated-text').length > lenn) {
                lenn = $(this).find('.animated-text').length;
            }
        });
        // $('.animated-letter .animated-text').removeClass('in');
        var i = 0;
        var showGallery = function() {
            $('.animated-letter:eq(0) .animated-text:eq(' + i + ')').addClass('in');
            $('.animated-letter:eq(1) .animated-text:eq(' + i + ')').addClass('in');
            $('.animated-letter:eq(2) .animated-text:eq(' + i + ')').addClass('in');
            i++;
            if (i < lenn) {
                setTimeout(showGallery, 50);
            }
        };
        showGallery();
        setTimeout(function() {
            $('.animated-letter .animated-text').removeClass('in');
        }, 2950);
    }, 3000);
    /********* HOME BANNER SLIDER  START FROM HERE ********/
    $('.ezeez-banner-slider').slick({
        autoplay: true,
        speed: 1000,
        autoplaySpeed: 2500,
        pauseOnFocus: false,
        pauseOnHover: false,
        pauseOnDotsHover: false,
        infinite: true,
        arrows: true,
        dots: false
    }).slickAnimation();
    $('.slick-nav').on('click touch', function(e) {
        e.preventDefault();
        var arrow = $(this);
        if (!arrow.hasClass('animate')) {
            arrow.addClass('animate');
            setTimeout(() => {
                arrow.removeClass('animate');
            }, 1600);
        }
    });
    /********* END HOME BANNER SLIDER  END FROM HERE ********/
    /********* START GALLERY LIGHTBOX MENU ********/
    // $(".gallery-column-img").click(function(e) {
    //     e.preventDefault();
    //     $("body").toggleClass("active-lightbox");
    // });
    // $(".gallery-close").click(function(e) {
    //     e.preventDefault();
    //     $("body").removeClass("active-lightbox");
    // });
    // $('.gallery > .galary-col div.bg').each(function() {
    //     $(this).wrapAll('<a href="" data-fancybox="gallery"></a>');
    // });
    // $('.gallery .galary-col a').each(function() {
    //     var link = $(this).children('.bg').css('background-image');
    //     console.log(link);
    //     link = link.replace(/(url\(|\)|")/g, '');
    //     $(this).attr('href', link);
    // });
    // $("[data-fancybox]").fancybox({
    //     loop: true,
    //     buttons: [
    //         "zoom",
    //         "share",
    //         "slideShow",
    //         "fullScreen",
    //         "download",
    //         "thumbs",
    //         "close"
    //     ]
    // });
    /********* END GALLERY LIGHTBOX MENU ********/



    jQuery(document).ready(function($) {
        //set animation timing
        var animationDelay = 2500,
            //loading bar effect
            barAnimationDelay = 3800,
            barWaiting = barAnimationDelay - 3000, //3000 is the duration of the transition on the loading bar - set in the scss/css file
            //letters effect
            lettersDelay = 50,
            //type effect
            typeLettersDelay = 150,
            selectionDuration = 500,
            typeAnimationDelay = selectionDuration + 800,
            //clip effect 
            revealDuration = 600,
            revealAnimationDelay = 1500;

        initHeadline();


        function initHeadline() {
            //insert <i> element for each letter of a changing word
            singleLetters($('.cd-headline.letters').find('b'));
            //initialise headline animation
            animateHeadline($('.cd-headline'));
        }

        function singleLetters($words) {
            $words.each(function() {
                var word = $(this),
                    letters = word.text().split(''),
                    selected = word.hasClass('is-visible');
                for (i in letters) {
                    if (word.parents('.rotate-2').length > 0) letters[i] = '<em>' + letters[i] + '</em>';
                    letters[i] = (selected) ? '<span class="in">' + letters[i] + '</span>' : '<span>' + letters[i] + '</span>';
                }
                var newLetters = letters.join('');
                word.html(newLetters);
            });
        }

        function animateHeadline($headlines) {
            var duration = animationDelay;
            $headlines.each(function() {
                var headline = $(this);

                if (headline.hasClass('loading-bar')) {
                    duration = barAnimationDelay;
                    setTimeout(function() { headline.find('.cd-words-wrapper').addClass('is-loading') }, barWaiting);
                } else if (headline.hasClass('clip')) {
                    var spanWrapper = headline.find('.cd-words-wrapper'),
                        newWidth = spanWrapper.width() + 10
                    spanWrapper.css('width', newWidth);
                } else if (!headline.hasClass('type')) {
                    //assign to .cd-words-wrapper the width of its longest word
                    var words = headline.find('.cd-words-wrapper b'),
                        width = 0;
                    words.each(function() {
                        var wordWidth = $(this).width();
                        if (wordWidth > width) width = wordWidth;
                    });
                    headline.find('.cd-words-wrapper').css('width', width);
                };

                //trigger animation
                setTimeout(function() { hideWord(headline.find('.is-visible').eq(0)) }, duration);
            });
        }
        // TYPING TEXT ANIMATION 
        function hideWord($word) {
            var nextWord = takeNext($word);

            if ($word.parents('.cd-headline').hasClass('type')) {
                var parentSpan = $word.parent('.cd-words-wrapper');
                parentSpan.addClass('selected').removeClass('waiting');
                setTimeout(function() {
                    parentSpan.removeClass('selected');
                    $word.removeClass('is-visible').addClass('is-hidden').children('span').removeClass('in').addClass('out');
                }, selectionDuration);
                setTimeout(function() { showWord(nextWord, typeLettersDelay) }, typeAnimationDelay);

            } else if ($word.parents('.cd-headline').hasClass('letters')) {
                var bool = ($word.children('span').length >= nextWord.children('span').length) ? true : false;
                hideLetter($word.find('span').eq(0), $word, bool, lettersDelay);
                showLetter(nextWord.find('span').eq(0), nextWord, bool, lettersDelay);

            } else if ($word.parents('.cd-headline').hasClass('clip')) {
                $word.parents('.cd-words-wrapper').animate({ width: '2px' }, revealDuration, function() {
                    switchWord($word, nextWord);
                    showWord(nextWord);
                });

            } else if ($word.parents('.cd-headline').hasClass('loading-bar')) {
                $word.parents('.cd-words-wrapper').removeClass('is-loading');
                switchWord($word, nextWord);
                setTimeout(function() { hideWord(nextWord) }, barAnimationDelay);
                setTimeout(function() { $word.parents('.cd-words-wrapper').addClass('is-loading') }, barWaiting);

            } else {
                switchWord($word, nextWord);
                setTimeout(function() { hideWord(nextWord) }, animationDelay);
            }
        }

        function showWord($word, $duration) {
            if ($word.parents('.cd-headline').hasClass('type')) {
                showLetter($word.find('span').eq(0), $word, false, $duration);
                $word.addClass('is-visible').removeClass('is-hidden');

            } else if ($word.parents('.cd-headline').hasClass('clip')) {
                $word.parents('.cd-words-wrapper').animate({ 'width': $word.width() + 10 }, revealDuration, function() {
                    setTimeout(function() { hideWord($word) }, revealAnimationDelay);
                });
            }
        }

        function hideLetter($letter, $word, $bool, $duration) {
            $letter.removeClass('in').addClass('out');

            if (!$letter.is(':last-child')) {
                setTimeout(function() { hideLetter($letter.next(), $word, $bool, $duration); }, $duration);
            } else if ($bool) {
                setTimeout(function() { hideWord(takeNext($word)) }, animationDelay);
            }

            if ($letter.is(':last-child') && $('html').hasClass('no-csstransitions')) {
                var nextWord = takeNext($word);
                switchWord($word, nextWord);
            }
        }

        function showLetter($letter, $word, $bool, $duration) {
            $letter.addClass('in').removeClass('out');

            if (!$letter.is(':last-child')) {
                setTimeout(function() { showLetter($letter.next(), $word, $bool, $duration); }, $duration);
            } else {
                if ($word.parents('.cd-headline').hasClass('type')) { setTimeout(function() { $word.parents('.cd-words-wrapper').addClass('waiting'); }, 200); }
                if (!$bool) { setTimeout(function() { hideWord($word) }, animationDelay) }
            }
        }

        function takeNext($word) {
            return (!$word.is(':last-child')) ? $word.next() : $word.parent().children().eq(0);
        }

        function takePrev($word) {
            return (!$word.is(':first-child')) ? $word.prev() : $word.parent().children().last();
        }

        function switchWord($oldWord, $newWord) {
            $oldWord.removeClass('is-visible').addClass('is-hidden');
            $newWord.removeClass('is-hidden').addClass('is-visible');
        }

    });

  $('body').on('click','.notify-btn',function(e){
    e.preventDefault();
    $('#notify-me-wrapper').slideToggle();
  });
  
  $('body').on('click', '.product_q',function(){
    var input = $(this).parent().find('input');
    var max = input.attr('max');
    var ip = parseInt(input.val());
    if($(this).hasClass('plus') && ip < max) {
      ip = ip + 1;
    } if($(this).hasClass('minus')) {
      ip = ip - 1;
    }
    if(ip==0) {
      return false;
    }
    input.val(ip);
  });

//   $('body').on('click', '.update-cart-btn',function(e){
//     e.preventDefault();
//     var q = $('.input-group-spinner').find('input').val();
//     var input = $('.cart-table-lineprice .money').text();
//     var id = $('.input-group-spinner').find('input[data-id]').text();
//     $.ajax({
//       type: 'POST',
//       url: '/cart/update.js',
//       data: 'updates['+id+']='+q,
//       dataType: 'json',
//       error: function(jqXHR, textStatus, errorThrown){
//         var response = $.parseJSON(jqXHR.responseText);       
//       }
//     }).done(function( data ) {
//       $.get( "/cart", function(data) {
//         var qty = $('.input-group-spinner').find('input').val();
//         var money = $('.cart-table-lineprice .money').text();
//         $('.input-group-spinner input').val(qty);
//         $('.cart-table-lineprice .money').html(money);
//         window.location.reload();
//       });    
//     });
//   });


$('body').on('click', '.update-cart-btn',function(e){
  e.preventDefault();
  var qty_up = '';
  if($('.cart-table-content-list').length > 0){
    $('.cart-table-content-list').each(function(i,v){
      console.log('i',i);
      if(i==0){
      qty_up += 'updates['+$(this).find('.input-group-spinner').find('input').attr('data-id')+']='+$(this).find('.input-group-spinner').find('input').val();
      }else{
        qty_up += '&updates['+$(this).find('.input-group-spinner').find('input').attr('data-id')+']='+$(this).find('.input-group-spinner').find('input').val();
      }
    });
  }
  $.ajax({
    type: 'POST',
    url: '/cart/update.js',
    data: qty_up,
    dataType: 'json',
    error: function(jqXHR, textStatus, errorThrown){
      var response = $.parseJSON(jqXHR.responseText);
      console.log(response.description);
    },
    success: function(data){
      window.location.reload();
    }
  });

});

var acc = document.getElementsByClassName("accordion");
var i;

for (i = 0; i < acc.length; i++) {
  acc[i].addEventListener("click", function() {
    this.classList.toggle("active");
    var panel = this.nextElementSibling;
    if (panel.style.display === "block") {
      panel.style.display = "none";
    } else {
      panel.style.display = "block";
    }
  });
}

  // collaction page slider
 if ($(window).width() < 640) {
        $('.product-shop-slider').addClass('twoslider');
      }
      $(window).on('resize', function () {
        if ($(window).width() < 640) {
          $('.product-shop-slider').addClass('twoslider');
        } else {
          $('.product-shop-slider').removeClass('twoslider');
        }
       });
     $('.twoslider').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      // autoplay: true,
      // autoplaySpeed: 2000,
      arrows: true,
      dots: true,
      responsive: [
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          }
        }
    ]
  });
  // homepage-featured-collection slider
    $('.homepage-featured-collection-row').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: false,
    autoplaySpeed: 2000,
    arrows: false,
    responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 640,
        settings: {
          autoplay: true,
          autoplaySpeed: 2000,
          slidesToShow: 1,
          slidesToScroll: 1,
        }
      }
  ]
  });
    if ($(window).width() < 540) {
      $('.product-media-wrp').addClass('slicksliderClass');
    }
    $(window).on('resize', function () {
      if ($(window).width() < 540) {
        $('.product-media-wrp').addClass('slicksliderClass');
      } else {
        $('.product-media-wrp').removeClass('slicksliderClass');
      }
     });
   $('.slicksliderClass').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    arrows: true,
    dots: true,
    responsive: [
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        }
      }
  ]
  });
});
if ($(window).width() < 768) {
        $('.ezeez-home-gallery-wrap').addClass('galary-col-slider');
      }
      $(window).on('resize', function () {
        if ($(window).width() < 768) {
          $('.ezeez-home-gallery-wrap').addClass('galary-col-slider');
        } else {
          $('.ezeez-home-gallery-wrap').removeClass('galary-col-slider');
        }
       });
     $('.galary-col-slider').slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 2000,
      arrows: false,
      dots: false,
       responsive: [
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
      }
    }
  ]
  });
jQuery(function($) {
    $(window).on('load', function() {
        // PARALLAX FUNCTIN CALL
        $(".parallax-object").paralmax();
    });
});
/* ========================================================================= */
jQuery.fn.extend({
    paralmax: function() {
        var t;
        return $(window).width(), t = $(window).height(), $(this).each(function() {
            function e() { s() ? $(i).data("speed") || 0 === $(i).data("speed") ? d.speed = $(i).data("speed") : d.speed = .5 : d.speed = 0 }

            function a() { var e, a, r = i;!0 === d.resizable && ($(window).width() > d.breakpoint ? (e = parseInt($(r).parent().outerHeight()), a = parseInt($(r).parent().offset().top) > parseInt(t) ? parseInt(t * d.speed) : parseInt($(r).parent().offset().top) * d.speed, $(r).height(e + a)) : $(r).height(e)) }

            function r() {
                var t = i,
                    e = $("html").scrollTop(),
                    a = $("body").scrollTop(),
                    r = (e > a ? e : a) - d.start,
                    n = parseInt(r * d.speed) + d.offset;
                $(t).css({ webkitTransform: "translate3d(0, " + n + "px, 0)", MozTransform: "translate3d(0, " + n + "px, 0)", msTransform: "translateY(" + n + "px)", OTransform: "translate3d(0, " + n + "px, 0)", transform: "translate3d(0, " + n + "px, 0)" })
            }

            function n() {
                if (!s()) {
                    var t = i;
                    $(t).css({ webkitTransform: "translate3d(0, 0, 0)", MozTransform: "translate3d(0, 0, 0)", msTransform: "translateY(0)", OTransform: "translate3d(0, 0, 0)", transform: "translate3d(0, 0, 0)" })
                }
            }

            function s() { return $(window).width() > d.breakpoint }
            var o, i = this,
                d = { start: (o = $(i).offset()).top, stop: o.top + $(i).outerHeight(), speed: 0, resizable: !!$(i).data("resize") && $(i).data("resize"), breakpoint: $(i).data("breakpoint") ? $(i).data("breakpoint") : 0, offset: $(i).data("offset") ? $(i).data("offset") * $(i).outerHeight() : 0 };
            e(), a(), n(), s() && r(), $(window).bind("scroll", function() { s() && r() }), $(window).bind("resize", function() { e(), a(), n() })
        })
    }
});
// AOS 
// AOS.init({
//     once: true,
// });
// let observer = new IntersectionObserver((entries, observer) => { entries.forEach(entry => { if (entry.isIntersecting) { entry.target.classList.add('aos-animate'); } else { entry.target.classList.remove('aos-animate'); } }); });
// document.querySelectorAll('[data-aos]').forEach(aosElem => { observer.observe(aosElem) });